// Port de app/(tabs)/trocaPlantao.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const TrocaPlantaoScreen = lazy(() => import("@/screens/TrocaPlantao"));

export default function TrocaPlantaoRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <TrocaPlantaoScreen />
    </Carregando>
  ) : null;
}
